<template>
    <!-- <layout title="チャット"> -->
        <main class="ly_main _brand"><div class="wrap"><div class="inner">
            <!--Heading-->
            <h1 class="heading_page-title flex _y-center">
                <div class="main"><span>チャット</span></div>
            </h1><!--/.heading_page-title-->
            <!--chat-->
            <div class="md_common-bl">
                <div class="inner">
                    <textarea maxlength="250" v-model="message"></textarea>
                    <input type="file" v-on:change="confirmImage" ref="file"/>
                    <button type="button" v-on:click="send()">送信</button>

                <div v-for="m in messages" :key="m.id">
                    <span v-text="m.user.name"></span>：&nbsp;
                    <span v-text="m.text"></span>
                    <img v-if="m.file_path"  v-bind:src="m.file_path" width="3" height="1"/>
                </div>
            </div><!--/.md_common-bl-->
        </div></div></div><div class="heading_page-title-en"><span></span></div></main>
    <!-- </layout> -->
</template>
<style>
* {
    color: #000;
    margin-bottom: 1rem;
}
body {
    padding: 1rem;
}
input, select, button, a {
    border: 1px solid #000!important;
}
button {
    margin-top: 1rem;
}
</style>
<script>
    import AdminLayout from '@/Layouts/AdminLayout'

    export default {
        // layout: AdminLayout,
        props: {
            messages: Array,
        },
        data: function() {
            return {
                message: '',
                file: '',
            }
        },
        mounted() {
            Echo.channel('chat')
                .listen('MessageCreated', (e) => {
                    this.getMessages();
                });
        },
        methods: {
            getMessages() {
                this.$inertia.get('/back-door/chat');
            },
            send() {
                const formData = new FormData()
                formData.append('message',this.message)
                formData.append('file',this.file)

                this.$inertia.post('/back-door/ajax/chat', formData)

                this.message = '';
                this.$refs.file.value = '';
            },
            confirmImage(e) {
                this.file = e.target.files[0];
            }
        },
    }
</script>
